import { TypedSunovationState } from '../sunovationStore'

export const selectOrderDialogOpenState = (state: TypedSunovationState) =>
  state.orderDialog.open
